import { motion } from "framer-motion";
import { ShieldCheck } from "@phosphor-icons/react";

const COMPLIANCE_TAGS = [
  "HIPAA-Compliant Vendors",
  "Enterprise-Grade Security",
  "Encrypted in Transit & at Rest",
];

export default function PartnersIntro() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="max-w-3xl"
    >
      <div
        className="font-mono text-[0.65rem] uppercase tracking-[0.32em] mb-5"
        style={{ color: "hsl(220 18% 72%)" }}
      >
        — Technology &amp; Trust
      </div>
      <h2
        className="font-display font-semibold tracking-[-0.02em] leading-[1.05]
                   text-[clamp(2.25rem,5vw,3.75rem)]"
        style={{ color: "hsl(38 38% 95%)" }}
      >
        Built with the <em className="not-italic text-accent">right people</em>.
      </h2>
      <p className="mt-6 text-base md:text-lg text-background/75 leading-relaxed max-w-2xl">
        The platforms and teams behind Integrated Clinical Intelligence — chosen to ensure
        your information remains{" "}
        <em className="not-italic text-accent">safe and secure</em>.
      </p>

      <div data-testid="partners-compliance-tags" className="mt-8 flex flex-wrap gap-2">
        {COMPLIANCE_TAGS.map((tag) => (
          <span
            key={tag}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full
                       border border-background/15 text-[0.65rem] uppercase tracking-[0.2em]
                       font-mono text-background/75"
          >
            <ShieldCheck size={12} weight="duotone" className="text-accent" />
            {tag}
          </span>
        ))}
      </div>
    </motion.div>
  );
}
